export enum CashRegisterPaths {
    ROOT = "cash-registers",
    TRANSACTIONS = "transactions",
}
